var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "80px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.376,1L60.7765,1C50.9362,1 45.0854,5.77617 43.2312,15.3355C41.3769,24.8878 46.6517,35.3742 59.0627,46.7808C66.5851,52.7018 65.3068,55.5183 55.2137,55.2304L0,55.2304L0,78.2261L80.0286,78.2261C91.1542,76.3718 96.8223,70.6686 97.0331,61.1163C97.2508,51.5569 91.5826,41.7167 80.0286,31.5884C73.5737,26.2434 74.9293,23.7148 84.0953,23.9958L123.653,23.9958L123.653,78.2261L148.791,78.2261L148.791,23.9958L173.29,23.9958L173.29,1L108.376,1Z",
    style: {
      fill: "black",
      strokeWidth: 2,
      stroke: "rgb(253,242,83)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.185,78.2261L187.59,1L225.94,1L251.773,78.2261L222.568,78.2261L217.701,66.4332L194.754,66.4332L189.887,78.2261L162.185,78.2261ZM206.842,20.224L197.88,48.7053L214.955,48.7053L206.842,20.224Z",
    style: {
      fill: "black",
      strokeWidth: 2,
      stroke: "rgb(253,242,83)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M259.057,78.2261L259.057,1L309.326,1C315.535,1.56893 320.634,3.21249 324.624,5.91664C328.62,8.62781 331.542,12.2661 333.396,16.8315C334.822,23.6797 334.892,28.9545 333.607,32.6631C332.329,36.3716 330.081,39.4691 326.871,41.9695C323.661,44.463 318.954,47.2621 312.969,48.688C312.969,48.688 313.335,51.5552 316.224,52.7419C324.866,56.2906 356.582,55.2304 356.582,55.2304L356.582,78.2261C356.582,78.2261 315.401,79.7015 311.468,78.2261C305.292,75.9094 286.976,52.7159 286.976,52.7159L286.976,78.2261L259.057,78.2261ZM286.976,20.2521L286.976,34.4822L306.439,34.4822C307.479,34.4822 308.602,34.0959 309.81,33.3303C311.018,32.5647 311.665,30.6262 311.735,27.5287C311.559,24.5717 310.836,22.6191 309.572,21.6709C308.307,20.7297 307.24,20.2521 306.39,20.2521L286.976,20.2521Z",
    style: {
      fill: "black",
      strokeWidth: 2,
      stroke: "rgb(253,242,83)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.669bd576388d6532e8d2b40fc9c965be.svg";
export { ForwardRef as ReactComponent };